import { render, staticRenderFns } from "./BrokerAuthAudit.vue?vue&type=template&id=5fd5b801&scoped=true"
import script from "./BrokerAuthAudit.vue?vue&type=script&lang=js"
export * from "./BrokerAuthAudit.vue?vue&type=script&lang=js"
import style0 from "./BrokerAuthAudit.vue?vue&type=style&index=0&id=5fd5b801&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd5b801",
  null
  
)

export default component.exports